import React from "react";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { STAGES } from "@/lib/constants";

export default function StatusTracker({ stage = 0, orientation = "horizontal" }) {
  const { t } = useTranslation();
  const label = (i) => t(`client.stage${i}`, { defaultValue: STAGES[i] });
  if (orientation === "vertical") {
    return (
      <ol className="relative" data-testid="status-tracker-vertical">
        {STAGES.map((key, i) => {
          const done = i < stage;
          const current = i === stage;
          return (
            <li key={key} className="flex gap-4 pb-8 last:pb-0 relative">
              {i < STAGES.length - 1 && (
                <span className={`absolute left-[13px] top-7 h-full w-px ${done ? "bg-orange-500" : "bg-border"}`} />
              )}
              <span
                className={`relative z-10 grid place-items-center h-7 w-7 rounded-full border shrink-0 ${
                  done ? "bg-orange-600 border-orange-600 text-white"
                    : current ? "bg-primary border-primary text-primary-foreground"
                    : "bg-card border-border text-muted-foreground"
                }`}
              >
                {done ? <Check className="h-4 w-4" /> : <span className="text-xs font-mono">{i + 1}</span>}
              </span>
              <div className="pt-0.5">
                <p className={`text-sm ${current ? "text-foreground font-medium" : done ? "text-slate-700" : "text-muted-foreground"}`}>{label(i)}</p>
                {current && <p className="text-xs text-orange-700 mt-0.5">{t("portal.statusInProgress")}</p>}
              </div>
            </li>
          );
        })}
      </ol>
    );
  }

  return (
    <div className="flex items-center" data-testid="status-tracker">
      {STAGES.map((key, i) => {
        const done = i < stage;
        const current = i === stage;
        return (
          <React.Fragment key={key}>
            <div className="flex flex-col items-center gap-1.5 min-w-0">
              <span
                className={`grid place-items-center h-6 w-6 rounded-full border text-[10px] font-mono ${
                  done ? "bg-orange-600 border-orange-600 text-white"
                    : current ? "bg-primary border-primary text-primary-foreground"
                    : "bg-card border-border text-muted-foreground"
                }`}
              >
                {done ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              <span className={`text-[10px] text-center leading-tight ${current ? "text-foreground" : "text-muted-foreground"}`}>{label(i)}</span>
            </div>
            {i < STAGES.length - 1 && <span className={`flex-1 h-px mx-1 ${i < stage ? "bg-orange-500" : "bg-border"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
